import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/apiClient";
import { store } from "../lib/storage";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator } from "./ui/dropdown-menu";
import { Bell } from "lucide-react";

const SEEN_KEY = "ulume_notifs_seen";
const ACTION_TYPES = ["payment", "lead"];

export default function NotificationBell() {
  const [items, setItems] = useState([]);
  const [seen, setSeen] = useState(() => store.get(SEEN_KEY) || "");
  const nav = useNavigate();

  const load = useCallback(() => {
    api.get("/notifications", { silent: true }).then(r => setItems(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(() => document.visibilityState === "visible" && load(), 30000);
    return () => clearInterval(t);
  }, [load]);

  const unread = items.filter(n => n.at > seen || (n.type === "order" && /Complete payment|rejected/.test(n.title + n.detail))).length;
  const markSeen = () => {
    const latest = items[0]?.at || "";
    store.set(SEEN_KEY, latest);
    setSeen(latest);
  };

  return (
    <DropdownMenu onOpenChange={(o) => { if (o) load(); else markSeen(); }}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={`Notifications${unread ? `, ${unread} new` : ""}`} className="relative" data-testid="notif-bell">
          <Bell className="w-5 h-5" />
          {unread > 0 && <span className="absolute top-1.5 right-1.5 w-2.5 h-2.5 rounded-full bg-secondary ring-2 ring-background" />}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 max-h-96 overflow-y-auto">
        <DropdownMenuLabel>Notifications</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {items.length === 0 && <div className="px-3 py-6 text-sm text-center text-muted-foreground">You're all caught up.</div>}
        {items.map((n, i) => (
          <DropdownMenuItem key={i} onClick={() => n.link && nav(n.link)} className="flex-col items-start gap-0.5 cursor-pointer">
            <span className={`text-sm ${ACTION_TYPES.includes(n.type) ? "font-semibold" : "font-medium"}`}>{n.title}</span>
            <span className="text-xs text-muted-foreground">{n.detail}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
